"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextProvider = void 0;
const SERVICE_NOT_INITIALIZED_ERROR = 'UserContextService is not initialized';
class UserContextProvider {
    static getUserContext() {
        return this.userContext;
    }
    static get userContext() {
        if (!window.userContextService) {
            throw new Error(SERVICE_NOT_INITIALIZED_ERROR);
        }
        return window.userContextService;
    }
}
exports.UserContextProvider = UserContextProvider;
